export default __webpack_public_path__ + "static/media/c_responsive.53876086.png";